import StatusDot from "@/v2-status-client/status/dot/StatusDot"
import type { PublicServiceStatus } from "@/v2-status-client/status/status.types"

export type StatusSummaryTitleProps = {
  name: string
  description?: string
  status: PublicServiceStatus
  summary: string
}

// Left column of a summary row: dot + name on the first line, then
// optional description, then summary. Splitting it out of the row
// keeps the row's responsibility narrowly to layout, and lets the
// title block reflow on its own when the page narrows.
function StatusSummaryTitle(props: Readonly<StatusSummaryTitleProps>) {
  const { name, description, status, summary } = props
  return (
    <div className="flex flex-col gap-1 min-w-0">
      <div className="flex items-center gap-2">
        <StatusDot status={status} />
        <span className="truncate text-sm font-medium text-foreground">
          {name}
        </span>
      </div>
      {description && (
        <div className="truncate text-xs text-muted-foreground">
          {description}
        </div>
      )}
      <div className="text-xs text-muted-foreground">{summary}</div>
    </div>
  )
}

export default StatusSummaryTitle
